module.exports = __webpack_public_path__ + "img/暂无订单.6ca005a0.png";